export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=706a77f44f552945cf272e49b735aa0ddbcf011454&name=pushAdClickData!'